export default "__VITE_ASSET__JlK1qS7I__"